import { render, staticRenderFns } from "./CustomersLocationsSearch.vue?vue&type=template&id=70d673fc&scoped=true&"
import script from "./CustomersLocationsSearch.vue?vue&type=script&lang=js&"
export * from "./CustomersLocationsSearch.vue?vue&type=script&lang=js&"
import style0 from "./CustomersLocationsSearch.vue?vue&type=style&index=0&id=70d673fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d673fc",
  null
  
)

export default component.exports